import getPlannerCardsEndpoint from '../planner-utils/api-handler';

/**
 * This checks for feedback or renewal banners/cards that need to be shown.
 * Run this every-day and also, when items are deleted / added.
 * @param {String} goalUID
 * @param {Object} store
 * @param {Object} isUnMountedRef
 */
const fetchFeatureCards = async (goalUID, apiCaller) => {
  const plannerCardsObject = await apiCaller(getPlannerCardsEndpoint(goalUID));
  const featureCards = plannerCardsObject?.data || [];
  return featureCards;
};

export default fetchFeatureCards;
